import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import {
  ButtonModule,
  CheckboxModule,
  DebugLanguageSwitchModule,
  IndicatorPopupModule,
  InputModule,
  RadiobuttonModule,
  SelectModule,
  SelectDateYmModule,
  RangeSliderModule,
  TextTooltipModule,
} from '@lib/components';
import { ThrottleClickDirectiveModule, TooltipDirectiveModule } from '@lib/directives';
import { PopupIndicatorPipeModule, DateFormatPipe, AmountFormatPipe } from '@lib/pipes';
import { TestComponent } from './test.component';
import { RouterModule } from '@angular/router';
import { DialogDisplayServiceModule } from '@lib/services';

@NgModule({
  declarations: [TestComponent],
  imports: [
    RouterModule.forChild([{ path: '', component: TestComponent }]),
    CommonModule,
    TranslateModule,
    ButtonModule,
    InputModule,
    FormsModule,
    ReactiveFormsModule,
    RadiobuttonModule,
    TextTooltipModule,
    TooltipDirectiveModule,
    CheckboxModule,
    SelectModule,
    RangeSliderModule,
    OverlayModule,
    SelectDateYmModule,
    DebugLanguageSwitchModule,
    IndicatorPopupModule,
    PopupIndicatorPipeModule,
    DialogDisplayServiceModule,
    ThrottleClickDirectiveModule,
  ],
  providers: [DateFormatPipe, AmountFormatPipe],
  exports: [TestComponent],
})
export class TestModule {}
